import { render, staticRenderFns } from "./SlsPD_Client.vue?vue&type=template&id=243e3fa8"
import script from "./SlsPD_Client.vue?vue&type=script&lang=js"
export * from "./SlsPD_Client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports